/** Displayable agent metadata for artwork detail page */
export interface AgentDisplayMetadata {
  nameKey: string
  descriptionKey: string
  avatarUrl: string
}

const MIO_AVATAR_URL =
  'https://images-ng.pixai.art/images/thumb/416b77f6-0500-42d8-821a-b1ca837cbd65'

export const DISPLAYABLE_AGENTS: Record<string, AgentDisplayMetadata> = {
  Kotone: {
    nameKey: 'common:tab.mio2',
    descriptionKey: 'artwork:creation-assistant.mio2-description',
    avatarUrl: MIO_AVATAR_URL,
  },
}
